import { DefaultService } from '@/services/DefaultService';

export default class UnidadeMedidaService extends DefaultService {

    constructor(http, router, env) {
        super(http, router, env)
    }

    save(um) {
        return this._http.post(`${this._env}/agro/unitmeasure`, um, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    find(id) {
        return this._http.get(`${this._env}/agro/unitmeasure/${id}.json`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    updateSituacao(unidadeMedida) {
        return this._http.post(`${this._env}/agro/unitmeasure/updatesituacao`, unidadeMedida, this._headers).then(res => {
            return res.body;
          }, err => {
            this.verifyError(err);
            throw err;
          });
    }

     findAll(page = 0, limit = 50,situacao = 2, order = 'asc', column = 'descricao',...params) {
        return this._http.get(encodeURI(`${this._env}/agro/unitmeasure.json?page=${page}&limit=${limit}&situacao=${situacao}&order=${order}&column=${column}&param=${params}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    findallcomboassproduto(idproduto, limit = 50, idsituacao, ...params) {
		return this._http
			.get(encodeURI(`${this._env}/vendas/unitmeasure/findallcombowithproduct.json?limit=${limit}&id=${idproduto}&idsituacao=${idsituacao}&param=${params}`), this._headers)
			.then((res) => { 
                return res.body; 
            }, (err) => {
                this.verifyError(err);
                throw new Error('Problems while jobs are loading');
			});
	}
}